var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("\n        404 page not found\n    ")]),_c('div',[_vm._v("\n        "+_vm._s(_vm.$t('common.error404'))+"\n    ")]),_c('router-link',{attrs:{"to":"/"}},[_c('b-button',[_vm._v("Back to home")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }